import request, {METHODS} from '@/api'
import UrlConfig from '@/api/UrlConfigs'
import {get} from 'lodash-es'

/**
 * 保险账户 - 账号列表
 */
export const getAccountsPageByRequest = (current, pageSize, params) => {
  return request(`${UrlConfig.plusPmWeb.FindAccountsPageByRequest}?current=${current}&pageSize=${pageSize}`, {
    method: METHODS.POST,
    data: params,
  }).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
/**
 * 保险账户 - 账户流水列表
 */
export const findAccountsDtlPageByRequest = (current, pageSize, params) => {
  return request(`${UrlConfig.plusPmWeb.FindAccountsDtlPageByRequest}?current=${current}&pageSize=${pageSize}`, {
    method: METHODS.POST,
    data: params,
  }).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
/**
 * 保险账户 - 投保记录列表
 */
export const findAccountsDtlPage = (current, pageSize, params) => {
  return request(`${UrlConfig.plusPmWeb.FindAccountsDtlPage}?current=${current}&pageSize=${pageSize}`, {
    method: METHODS.POST,
    data: params,
  }).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
/**
 * 保险账户-列表页面-初始化账户
 */
export const addInsurAccount = data => {
  return request(UrlConfig.plusPmWeb.AddInsurAccount, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 手动充值
 */
export const manualAddBlance = data => {
  return request(UrlConfig.plusPmWeb.ManualAddBlance, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 修改状态
 */
export const UpdateInsuranceStatus = data => {
  return request(UrlConfig.plusPmWeb.UpdateInsuranceStatus, {
    method: METHODS.POST,
    params: data,
  }).then((resp: any) => {
    return resp
  })
}

/**
 * 保险管理-保险配置-分页
 */
export const getNewInsurAccountsFindConfPageByRequest = (current, pageSize, params) => {
  return request(`${UrlConfig.plusPmWeb.NewInsurAccountsFindConfPageByRequest}?current=${current}&pageSize=${pageSize}`, {
    method: METHODS.POST,
    data: params,
  }).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return {records, total}
  })
}
/**
 * 保险管理-保险配置-删除
 */
export const newInsurAccountsDeleteById = (id) => {
  return request(`${UrlConfig.plusPmWeb.NewInsurAccountsDeleteById}?id=${id}`, {
    method: METHODS.POST,
    data: {id},
  })
}
/**
 * 保险管理-保险配置-编辑查询
 */
export const getNewInsurAccountsDetail = (id: string) => {
  return request(`${UrlConfig.plusPmWeb.NewInsurAccountsDetail}?id=${id}`, {
    method: METHODS.POST,
  })
}
/**
 * 保险管理-保险配置- - 新增
 */
export const newInsurAccountsInsertConfBatch = (params: any) => {
  return request(UrlConfig.plusPmWeb.NewInsurAccountsInsertConfBatch, {
    method: METHODS.POST,
    data: params,
  })
}
/**
 * 保险管理-保险配置- - 编辑
 */
export const newInsurAccountsUpdateConfigStatus = (params: any) => {
  return request(UrlConfig.plusPmWeb.NewInsurAccountsUpdateConfigStatus, {
    method: METHODS.POST,
    data: params,
  })
}
/**
 * 保险账户-定时任务-手动续保
 */
export const manualDiscountInsurAmountFromAccount = (id: string) => {
  return request(`${UrlConfig.plusPmWeb.ManualDiscountInsurAmountFromAccount}?id=${id}`, {
    method: METHODS.POST,
  })
}